import React from 'react';
import type ServicedeskReportsSatisfactionType from '@atlassian/jira-spa-apps-servicedesk-reports-satisfaction/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { SATISFACTION_ROUTE_SUFFIX } from '../../common/constants.tsx';

export const LazyServicedeskReportsSatisfaction = lazyForPaint<
	typeof ServicedeskReportsSatisfactionType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-reports-satisfaction", jiraSpaEntry: "async-servicedesk-reports-satisfaction" */ '@atlassian/jira-spa-apps-servicedesk-reports-satisfaction'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyServicedeskReportsSatisfaction}
		pageId={`spa-apps/servicedesk${SATISFACTION_ROUTE_SUFFIX}}`}
		shouldShowSpinner
	/>
);
